import React from 'react';

import SideMenu from './SideMenu';
import SideMenuUser from './SideMenuUser';

interface Props {
    user?: any;
}

const SideMenuBase: React.FC<Props> = ({ user }) => {
    return (
        <div className="aside">
            <div className="aside-menu flex-column-fluid">
                <SideMenu user={user} />
            </div>

            <div className="aside-footer flex-column-auto pb-5">
                <div className="aside-user">
                    <SideMenuUser user={user} />
                </div>
            </div>
        </div>
    );
};

export default SideMenuBase;
